import React from 'react';
import { generateBemCss } from 'general/js/helpers';
import { getHoleParBemClassForCustomEvent } from '../../scores/js/score-themes';
import { hasValue } from '../../../general/js/general-helpers';

const CustomEventLeaderboardScoreCell = ({ childCss, r2hAttributes, holePar, playerPar, status }) => {
    r2hAttributes = hasValue(r2hAttributes) ? r2hAttributes : {};

    const bemCss = generateBemCss('score-cell', [getHoleParBemClassForCustomEvent(holePar, playerPar), 'has-border']);
    let playerParText = playerPar;

    if (!playerPar || playerPar === 0) {
        playerParText = '-';
    }

    return (
        <div className={`${childCss} ${bemCss}`} title={status} {...r2hAttributes}>{playerParText}</div>
    );
};

CustomEventLeaderboardScoreCell.defaultProps = {
    childCss: ''
};

export default CustomEventLeaderboardScoreCell;
